import { serviceMaker, methods, api } from "@/http/index.js";

export const updateTermsAndConditions = (data) =>
  serviceMaker(
    `/input/${data.id}?type=${data.type}`,
    methods.PUT,
    api.NGB,
    data.payload
  );
export const createTermsAndConditions = (payload) =>
  serviceMaker(`/input`, methods.POST, api.NGB, payload);
export const getTermsConditions = (data) =>
  serviceMaker(
    `/${data.screen}/${data.id}/documents/plan/${data.id}`,
    methods.GET,
    api.NGB
  );
export const updateDigitalContent = (data) =>
  serviceMaker(`/input/${data.id}`, methods.PUT, api.NGB, data.payload);
export const createDigitalContent = (payload) =>
  serviceMaker(`/input`, methods.POST, api.NGB, payload);
export const getDigitalContent = (id) =>
  serviceMaker(`/input/${id}`, methods.GET, api.NGB);
export const getPlansList = (id) =>
  serviceMaker(`/plans?userId=${id}`, methods.GET, api.NGB);
export const getPlanTemplate = () =>
  serviceMaker(`/plans/template`, methods.GET, api.NGB);
export const getPlanAttributes = () =>
  serviceMaker(`/mcodes/Plan Attributes`, methods.GET, api.NGB);
export const getPlanAttributesValue = () =>
  serviceMaker(`/mcodes/Plan_Attribute_Value`, methods.GET, api.NGB);
export const createPlans = (data) =>
  serviceMaker(`/plans`, methods.POST, api.NGB, data);
export const createPlanDiscount = (data) =>
  serviceMaker(`/plandiscounts`, methods.POST, api.NGB, data);
export const updatePlanDiscount = (data) =>
  serviceMaker(
    `/plandiscounts/plan/${data.planId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const viewPlanDiscount = (id) =>
  serviceMaker(`/plandiscounts/plan/${id}`, methods.GET, api.NGB);
export const createPlanPromo = (data) =>
  serviceMaker(`/planpromotion`, methods.POST, api.NGB, data);
export const updatePlanPromo = (data) =>
  serviceMaker(
    `/planpromotion/plan/${data.planId}`,
    methods.PUT,
    api.NGB,
    data
  );
export const viewPlanPromo = (id) =>
  serviceMaker(`/planpromotion/plan/${id}`, methods.GET, api.NGB);
// export const getPlanWithTemplate = (id) =>
//   serviceMaker(`/plans/${id}?template`, methods.GET, api.NGB);
export const getPlanWithTemplate = (id) =>
  serviceMaker(`/plans/${id}?template&isdeleted=Y`, methods.GET, api.NGB);
export const getPlanWithTemplateTrue = (id) =>
  serviceMaker(`/prices/${id}?template=true`, methods.GET, api.NGB);
export const updatePlans = (id, data) =>
  serviceMaker(`/plans/${id}`, methods.PUT, api.NGB, data);
export const getPriceWithTemplate = (id) =>
  serviceMaker(`/prices/${id}?template=true`, methods.GET, api.NGB);
export const savePrice = (id, data) =>
  serviceMaker(`/prices/${id}`, methods.POST, api.NGB, data);
export const updatePrice = (id, data) =>
  serviceMaker(`/prices/update/${id}`, methods.PUT, api.NGB, data);
export const deletePrice = (id) =>
  serviceMaker(`/prices/${id}`, methods.DELETE, api.NGB);
export const deletePlan = (id) =>
  serviceMaker(`/plans/${id}`, methods.DELETE, api.NGB);
export const discountTemplate = (type) =>
  serviceMaker(`/discounts/applicableTo/${type}`, methods.GET, api.NGB);
export const productDiscountTemplate = () =>
  serviceMaker(`discounts/applicableTo/Product`, methods.GET, api.NGB);
export const getDiscountCode = () =>
  serviceMaker(`/discounts`, methods.GET, api.NGB);
export const uploadDocument = (id, data) =>
  serviceMaker(`/plandocument/${id}/documents`, methods.POST, api.NGB, data);
export const getDocument = (id) =>
  serviceMaker(`/plandocument/${id}/documents`, methods.GET, api.NGB);
export const getImage = (id, docId) =>
  serviceMaker(
    `/plandocument/${id}/documents/${docId}`,
    methods.GET,
    api.NGB
  );
export const getDcRules = () =>
  serviceMaker(`/enum/termination_rule`, methods.GET, api.NGB);
export const getExternalPlans = () =>
  serviceMaker(`/extrnal/package`, methods.GET, api.NGB);
export const getLocaleLanguage = () =>
  serviceMaker(`/enum/storage_type_enum`, methods.GET, api.NGB);
export const getContentTag = () =>
  serviceMaker(`/mcodes/content_tag`, methods.GET, api.NGB);
export const getContentTagValue = () =>
  serviceMaker(`/mcodes/content_tag_value`, methods.GET, api.NGB);
export const getContentType = () =>
  serviceMaker(`/mcodes/Plan Content Type`, methods.GET, api.NGB);
export const getDiscountContentType = () =>
  serviceMaker(`/mcodes/Discount_Content_Type`, methods.GET, api.NGB);
export const getPromoContentType = () =>
  serviceMaker(`/mcodes/Promo_Content_Type`, methods.GET, api.NGB);
export const deleteContent = (data) =>
  serviceMaker(
    `/plan/${data.id}/documents/deletecontent/${data.docId}`,
    methods.DELETE,
    api.NGB
  );
export const createPlanContent = (screen, payload) =>
  serviceMaker(
    `/${screen}/${payload.planId}/documents/plan`,
    methods.POST,
    api.NGB,
    payload
  );
export const editPlanContent = (screen, payload) =>
  serviceMaker(
    `/${screen}/${payload.planId}/documents/plan/${payload.planId}?type=${payload.type}&storageTypeEnum=${payload.locale}`,
    methods.PUT,
    api.NGB,
    payload
  );
export const sendApprovalStatus = (id, data) =>
  serviceMaker(`/plans/status/${id}`, methods.PUT, api.NGB, data);
export const approvalActionApi = (payload) =>
  serviceMaker(
    `/makercheckers/${payload.id}?command=${payload.action}`,
    methods.POST,
    api.NGB,
    payload.data
  );
export const makerCheckActionData = (id) =>
  serviceMaker(
    `/audits/actions?makerId=${id}&checkerId=${id}`,
    methods.GET,
    api.NGB
  );
